import SelectKitRowComponent from "select-kit/components/select-kit/select-kit-row";

export default SelectKitRowComponent.extend({
  classNames: ["user-row", "wizard-user-chooser-row"],
});
